import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';

interface IContactService {
  contact: (productId: number, options: any) => Promise<HttpResponse<any>>;
}

export const contactService: IContactService = {
  contact(productId, options) {
    return ajax.post(`${config.benefitApiUrl}/contact`, { productId, options });
  },
};
